import { render, staticRenderFns } from "./DuplicatesTabDuplicates.vue?vue&type=template&id=54a3437c&scoped=true&"
import script from "./DuplicatesTabDuplicates.vue?vue&type=script&lang=js&"
export * from "./DuplicatesTabDuplicates.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatesTabDuplicates.vue?vue&type=style&index=0&id=54a3437c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a3437c",
  null
  
)

export default component.exports